import { getVisibleOffers } from './filters-selector';

const getOffers = state => state.shop.list;

const getModerOffers = state => state.shop.moderList;

export const getVisibleShopOffers = getVisibleOffers(getOffers);
export const getVisibleModeratorShopOffers = getVisibleOffers(getModerOffers);


